import Feature from "ol/Feature";
import LineString from "ol/geom/LineString";
import { trackLine } from "../styles/styles";

export class TrackLine {
  constructor(
    {
    imageWidthInPixels,
    imageHeightInPixels,
    trackObjectId,
    coordinates,
    type,
    color,
    maxLines
    }
    ) {
    this.maxLines = maxLines || 100;
    if (
      !imageWidthInPixels ||
      !imageHeightInPixels ||
      !trackObjectId
    ) {
      return;
    }

    if(!Array.isArray(coordinates)){
      return
    }

    this.mapSizesInPixel = {
      imageWidthInPixels,
      imageHeightInPixels,
    };

    this.type = type;
    this.trackObjectId = trackObjectId;

    this.coordinates = coordinates

    this.openLayersFeature = new Feature({
      type,
      payload: this,
      geometry: new LineString(this.coordinates),
    });

    this.openLayersFeature.setId(trackObjectId);
    const featureStyle = this.getTrackLineStyle(color);
    this.openLayersFeature.setStyle(featureStyle);
    
    return this.openLayersFeature;
  }

  isNewCoordinateTheSame(newCoordinates, oldCoordinates){
    const lastOldPoint = oldCoordinates[oldCoordinates.length -1];
    const checkX = newCoordinates[0] === lastOldPoint[0]
    const checkY = newCoordinates[1] === lastOldPoint[1]

    return checkX || checkY
  }

  updateTrackLine(newCoordinates) {
    const geometry = this.openLayersFeature.getGeometry();

    const oldCoordinates = geometry.getCoordinates();
    if(!Array.isArray(newCoordinates)){
      return
    }

    if (this.isNewCoordinateTheSame(newCoordinates, oldCoordinates)) {
      return
    }
    const resultCoordinates = [...oldCoordinates];
    if(resultCoordinates.length > this.maxLines){
      resultCoordinates.shift();
      resultCoordinates.push(newCoordinates)
    } else {
      resultCoordinates.push(newCoordinates);
    }

    geometry.setCoordinates(resultCoordinates);
  }

  getTrackLineStyle(color) {
    return trackLine(color)
  }
}
